import { render, staticRenderFns } from "./errorModal.vue?vue&type=template&id=2e029c5d&"
import script from "./errorModal.vue?vue&type=script&lang=ts&"
export * from "./errorModal.vue?vue&type=script&lang=ts&"
import style0 from "./errorModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports